import { storyChapterSectionDomIdFromEventIdOnly } from "@/features/story/lib/story-section-anchor"

/** Minimal event fields needed to resolve `/story/[scope]` (matches {@link getStoryEvents} lookup). */
export type StoryScopeSource = {
  seriesId?: string | null
  createdByUserId?: string | null
}

/**
 * Story URL: `/story/<scope>` where `scope` is either `seriesId` or host `createdByUserId`.
 * Normalize the route segment via `resolveStoryGroupingKey` and compose with
 * `resolveStoryScopeRows` in `features/story/server/story-scope-grouping.ts`.
 */
export function storyHrefFromScopeSource(
  source: StoryScopeSource,
): string | null {
  const series = source.seriesId?.trim()
  if (series) return `/story/${encodeURIComponent(series)}`
  const owner = source.createdByUserId?.trim()
  if (owner) return `/story/${encodeURIComponent(owner)}`
  return null
}

/** Same as {@link storyHrefFromScopeSource} plus `#story-event-<eventId>` for chapter deep links. */
export function storyHrefToEventChapter(
  source: StoryScopeSource,
  eventId: string,
): string | null {
  const base = storyHrefFromScopeSource(source)
  if (!base) return null
  const id = eventId.trim()
  if (!id) return base
  return `${base}#${storyChapterSectionDomIdFromEventIdOnly(id)}`
}
